import React, { useState } from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const LanguageSwitcher = () => {
    const { currentLanguage, changeLanguage } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const languages = [
        {
            code: 'de',
            name: 'Deutsch',
            flag: (
                <svg className="w-4 h-4" viewBox="0 0 24 16" fill="none">
                    <rect width="24" height="16" fill="#000" />
                    <rect width="24" height="10.67" y="5.33" fill="#DD0000" />
                    <rect width="24" height="5.33" y="10.67" fill="#FFCE00" />
                </svg>
            )
        },
        {
            code: 'en',
            name: 'English',
            flag: (
                <svg className="w-4 h-4" viewBox="0 0 24 16" fill="none">
                    <rect width="24" height="16" fill="#012169" />
                    <path d="M0 0L24 16M24 0L0 16" stroke="#fff" strokeWidth="2" />
                    <path d="M10 0v16M0 5.33h24M0 10.67h24" stroke="#fff" strokeWidth="1.33" />
                    <path d="M0 0L24 16M24 0L0 16" stroke="#C8102E" strokeWidth="0.8" />
                    <path d="M12 0v16M0 8h24" stroke="#C8102E" strokeWidth="0.8" />
                </svg>
            )
        },
        {
            code: 'it',
            name: 'Italiano',
            flag: (
                <svg className="w-4 h-4" viewBox="0 0 24 16" fill="none">
                    <rect width="8" height="16" fill="#009246" />
                    <rect width="8" height="16" x="8" fill="#fff" />
                    <rect width="8" height="16" x="16" fill="#CE2B37" />
                </svg>
            )
        }
    ];

    const currentLang = languages.find(lang => lang.code === currentLanguage);

    const handleLanguageChange = (langCode) => {
        changeLanguage(langCode);
        setIsOpen(false);
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center px-6 py-3 rounded-2xl text-sm font-semibold transition-all duration-200 border border-blue-100 bg-white/80 hover:bg-gray-100 text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
            >
                <span className="mr-2">{currentLang?.flag}</span>
                <span>{currentLang?.name}</span>
                <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isOpen && (
                <>
                    <div
                        className="fixed inset-0 z-10"
                        onClick={() => setIsOpen(false)}
                    />
                    <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-gray-200 z-20">
                        {languages.map((language) => (
                            <button
                                key={language.code}
                                onClick={() => handleLanguageChange(language.code)}
                                className={`w-full flex items-center px-4 py-3 text-sm hover:bg-gray-50 transition-colors duration-200 first:rounded-t-lg last:rounded-b-lg ${currentLanguage === language.code
                                    ? 'bg-blue-50 text-blue-600 font-semibold'
                                    : 'text-gray-700'
                                    }`}
                            >
                                <span className="mr-3">{language.flag}</span>
                                <span>{language.name}</span>
                                {currentLanguage === language.code && (
                                    <svg className="ml-auto w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                )}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default LanguageSwitcher;
